import { useInitVarify } from "./useInitVarify"
import { VarifyContext } from "./VarifyContext"

export const VarifyProvider = ({children}) => {
    const varifyContext = useInitVarify()
    return <VarifyContext.Provider value={varifyContext}>
        {children}
    </VarifyContext.Provider>
}